import React, { ChangeEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  border?: string;
  margin?: string;
  placeholder?: string;
  svg?: React.ReactNode;
  icon?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  name?: string;
  // `current-password` for login (so password managers offer to fill),
  // `new-password` for sign-up / change-password (so they offer to
  // generate). Defaults to `current-password` since that's the safer
  // default for the most common case (login).
  autoComplete?: "current-password" | "new-password" | "off";
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  showIcon?: boolean;
}

const Password: React.FC<InputProps> = ({
  label = "Password",
  value,
  placeholder = "••••••••",
  svg,
  border,
  margin,
  icon = "bi-lock",
  hint,
  error,
  required,
  name = "password",
  autoComplete = "current-password",
  onChange,
  showIcon = true,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const useIcon = showIcon ? icon : undefined;
  return (
    <Field
      label={label}
      margin={margin}
      icon={svg ? undefined : useIcon}
      iconNode={svg}
      hint={hint}
      error={error}
      required={required}
      rightSlot={
        <button
          type="button"
          className="field__eyeBtn"
          aria-label={showPassword ? "Hide password" : "Show password"}
          onClick={() => setShowPassword((v) => !v)}
        >
          <i
            className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
            aria-hidden="true"
          />
        </button>
      }
    >
      <Form.Control
        className={border}
        value={value}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        type={showPassword ? "text" : "password"}
        autoComplete={autoComplete}
        {...rest}
      />
    </Field>
  );
};

export default Password;
